define('home/templates/ProfileModuleEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"post-comments__wrapper\">\n<div class=\"empty-message\">\n<span class=\"icon-heart-break text-gray-light icon-huge\"></span>\n<p class=\"text-gray-light\">"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Nothing to see.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n</div>\n";
},"useData":true})

});
